export default __webpack_public_path__ + "static/media/mapPin.1f2798d0.svg";